import React from 'react'
import MiCompAPI from '../../../util/api';
import {
  Form,
  Input,
  Icon,
  Radio,
  Select,
  Row,
  Col,
  Button,
  Divider,
} from 'antd';


const { Option } = Select;
class EAD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, disabler: false, disableb: false, disablem: false,
      rtype: "d", btype: "d", mtype: "d"
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);

  }
  handleChange = e => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };


  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let address = [];
        if (this.state.rtype === "d") {
          address.push(this.raddress({ ...values, addresS_CODEr: '01' }))
        } else if (this.state.rtype === "b") {
          address.push(this.baddress({ ...values, addresS_CODEb: '01' }))
        } else if (this.state.rtype === "m") {
          address.push(this.maddress({ ...values, addresS_CODEm: '01' }))
        }
        if (this.state.btype === "d") {
          address.push(this.baddress({ ...values, addresS_CODEb: '02' }))
        } else if (this.state.btype === "r") {
          address.push(this.raddress({ ...values, addresS_CODEr: '02' }))
        } else if (this.state.btype === "m") {
          address.push(this.maddress({ ...values, addresS_CODEm: '02' }))
        }
        if (this.state.mtype === "d") {
          address.push(this.maddress({ ...values, addresS_CODEm: '03' }))
        } else if (this.state.mtype === "r") {
          address.push(this.raddress({ ...values, addresS_CODEr: '03' }))
        } else if (this.state.mtype === "b") {
          address.push(this.baddress({ ...values, addresS_CODEb: '03' }))
        }
        this.props.submitHandler({ address: address });
      }
    });
  }
  raddress = (values) => {
    return {
      addresS_CODE: values.addresS_CODEr,
      addR_LINE_1: values.addR_LINE_1r,
      addR_LINE_2: values.addR_LINE_2r,
      addR_LINE_3: values.addR_LINE_3r,
      city: values.cityr,
      statE_CODE: values.statE_CODEr,
      ziP_CODE: values.ziP_CODEr,
      countrY_CODE: values.countrY_CODEr,

    };
  }
  baddress = (values) => {
    return {
      addresS_CODE: values.addresS_CODEb,
      addR_LINE_1: values.addR_LINE_1b,
      addR_LINE_2: values.addR_LINE_2b,
      addR_LINE_3: values.addR_LINE_3b,
      city: values.cityb,
      statE_CODE: values.statE_CODEb,
      ziP_CODE: values.ziP_CODEb,
      countrY_CODE: values.countrY_CODEb,

    };
  }
  maddress = (values) => {
    return {
      addresS_CODE: values.addresS_CODEm,
      addR_LINE_1: values.addR_LINE_1m,
      addR_LINE_2: values.addR_LINE_2m,
      addR_LINE_3: values.addR_LINE_3m,
      city: values.citym,
      statE_CODE: values.statE_CODEm,
      ziP_CODE: values.ziP_CODEm,
      countrY_CODE: values.countrY_CODEm,

    };
  }
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { stateabb } = this.props;
    if (this.props.niprappoinment && this.props.niprappoinment.address){
      let { address } = this.props.niprappoinment;
      setTimeout(() => {
        setFieldsValue({
          addresS_CODEr: address[0].addresS_CODE,
          addR_LINE_1r: address[0].addR_LINE_1,
          addR_LINE_2r: address[0].addR_LINE_2,
          addR_LINE_3r: address[0].addR_LINE_3,
          cityr: address[0].city,
          statE_CODEr: address[0].statE_CODE,
          ziP_CODEr: address[0].ziP_CODE,
          countrY_CODEr: address[0].countrY_CODE,
          addresS_CODEb: address[1].addresS_CODE,
          addR_LINE_1b: address[1].addR_LINE_1,
          addR_LINE_2b: address[1].addR_LINE_2,
          addR_LINE_3b: address[1].addR_LINE_3,
          cityb: address[1].city,
          statE_CODEb: address[1].statE_CODE,
          ziP_CODEb: address[1].ziP_CODE,
          countrY_CODEb: address[1].countrY_CODE,
          addresS_CODEm: address[2].addresS_CODE,
          addR_LINE_1m: address[2].addR_LINE_1,
          addR_LINE_2m: address[2].addR_LINE_2,
          addR_LINE_3m: address[2].addR_LINE_3,
          citym: address[2].city,
          statE_CODEm: address[2].statE_CODE,
          ziP_CODEm: address[2].ziP_CODE,
          countrY_CODEm: address[2].countrY_CODE,
          adtr: 'd',
          adtb: 'd',
          adtm: 'd',
        })
      }, 100);
    }
    
    else {
      setTimeout(() => {
        setFieldsValue({
          statE_CODEm: stateabb,
          statE_CODEr: stateabb,
          statE_CODEb: stateabb,
          countrY_CODEb: '1',
          countrY_CODEr: '1',
          countrY_CODEm: '1',
          adtr: 'd',
          adtb: 'd',
          adtm: 'd',
        })
      }, 100);
    }

  }

  render() {

    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { States, stateabb, getstatename } = this.props;
    return (

      <div ><Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
        <Row>


          <Col sm={24}>

            <div style={{ marginLeft: "15px", marginTop: "16px", marginBottom: "-16px" }}> <p style={{ marginBottom: "10px" }}>
              Resident Address</p><Divider style={{ marginTop: "6px" }}></Divider></div>
            {getFieldDecorator('adtr', {
            })(
              <Radio.Group className="mi_input_pop" onChange={(e) => {
                this.setState({
                  disableb: this.state.disableb,
                  disabler: this.state.disabler,
                  disablem: this.state.disablem,
                  rtype: this.state.rtype,
                  btype: this.state.btype,
                  mtype: this.state.mtype,

                })
                if (e.target.value === "b" || e.target.value === "m") {
                  this.setState({
                    disabler: true,
                    rtype: e.target.value,
                  })
                }
                if (e.target.value === "d") {
                  this.setState({
                    disabler: false,
                    rtype: e.target.value,

                  })
                }
              }}>

                <Radio disabled={this.state.disableb} value="b">Same as business address</Radio>
                <Radio disabled={this.state.disablem} value="m">Same as mailing address</Radio>
                <Radio value="d" disabled={this.state.disableb&&this.state.disablem}>Use a diffrent address</Radio>
              </Radio.Group>)}
            {!this.state.disabler ? <>
              <Row>

                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 1 *</legend>
                      {getFieldDecorator('addR_LINE_1r', {
                        rules: [{ required: true, message: 'Address Line 1 is a required' }
                          , {
                          max: 50,
                          message: "Address Line 1 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 1" />)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 2</legend>
                      {getFieldDecorator('addR_LINE_2r', {
                        rules: [{
                          max: 50,
                          message: "Address Line 2 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 2" />)}
                    </fieldset>
                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 3</legend>
                      {getFieldDecorator('addR_LINE_3r', {
                        rules: [{
                          max: 50,
                          message: "Address Line 3 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 3" />)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">City *</legend>
                      {getFieldDecorator('cityr', {
                        rules: [{ required: true, message: 'City is a required field' }, {
                          pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                          message: "City is not valid"
                        }, {
                          max: 35,
                          message: "City is  must be at most 35 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={35} className="mi_input" type="text" placeholder="City" />)}
                    </fieldset>
                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State *</legend>
                      {getFieldDecorator('statE_CODEr', {
                        rules: [{ required: true, message: 'Please select state ' },
                        {
                          validator(rule, value) {

                            if (!value || stateabb === value || getFieldValue('statE_CODEb') === stateabb) {
                              return Promise.resolve();
                            }
                            return Promise.reject(getstatename(stateabb) + ' : Residence or business address must be in the state');
                          }
                        }],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={this.onChange}
                        placeholder="Please Select State ">
                        {States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset>
                      <legend className="legend-font">ZIP Code *</legend>
                      {getFieldDecorator('ziP_CODEr', {
                        rules: [{ required: true, message: 'Please enter a valid zip code' },
                        { pattern: /^(?:\d{5}|\d{9})$/, message: "ZIP is  must be at most 5/9 characters" }]
                      })(<Input maxLength={9} autoComplete={"nope"} className="ant-input mi_input" type="number" placeholder="Enter ZIP Code " />)}
                    </fieldset>

                  </Form.Item></Col>
              </Row><Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Country *</legend>
                      {getFieldDecorator('countrY_CODEr', {
                        rules: [{ required: true, message: 'Please select Country' },],
                      })(<Select disabled suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }

                        placeholder="Please Select Country ">
                        <Option value="1" key={0} >United States of America</Option>


                      </Select>)} </fieldset>
                  </Form.Item></Col>

              </Row></> : ""}
          </Col>
        </Row>
        <Row>

          <Col sm={24}>
            <div style={{ marginLeft: "15px", marginTop: "16px", marginBottom: "-16px" }}>
              <p style={{ marginBottom: "10px" }}> Business Address</p><Divider style={{ marginTop: "6px" }}></Divider></div>

            {getFieldDecorator('adtb', {
            })(
              <Radio.Group className="mi_input_pop" onChange={(e) => {
                this.setState({
                  disableb: this.state.disableb,
                  disabler: this.state.disabler,
                  disablem: this.state.disablem,
                  rtype: this.state.rtype,
                  btype: this.state.btype,
                  mtype: this.state.mtype,
                })
                if (e.target.value === "r" || e.target.value === "m") {
                  this.setState({
                    disableb: true,
                    btype: e.target.value
                  })
                }
                if (e.target.value === "d") {
                  this.setState({
                    disableb: false,
                    btype: e.target.value
                  })
                }
              }}>

                <Radio disabled={this.state.disabler} value="r">Same as resident address</Radio>
                <Radio disabled={this.state.disablem} value="m">Same as mailing address</Radio>
                <Radio value="d" disabled={this.state.disabler&&this.state.disablem}>Use a diffrent address</Radio>
              </Radio.Group>)}
            {!this.state.disableb ? <>
              <Row>

                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 1 *</legend>
                      {getFieldDecorator('addR_LINE_1b', {
                        rules: [{ required: true, message: 'Address Line 1 is a required' }
                          , {
                          max: 50,
                          message: "Address Line 1 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 1" />)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 2</legend>
                      {getFieldDecorator('addR_LINE_2b', {
                        rules: [{
                          max: 50,
                          message: "Address Line 2 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 2" />)}
                    </fieldset>
                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 3</legend>
                      {getFieldDecorator('addR_LINE_3b', {
                        rules: [{
                          max: 50,
                          message: "Address Line 3 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 3" />)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">City *</legend>
                      {getFieldDecorator('cityb', {
                        rules: [{ required: true, message: 'City is a required field' }, {
                          pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                          message: "City is not valid"
                        }, {
                          max: 35,
                          message: "City is  must be at most 35 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={35} className="mi_input" type="text" placeholder="City" />)}
                    </fieldset>
                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State *</legend>
                      {getFieldDecorator('statE_CODEb', {
                        rules: [{ required: true, message: 'Please select state ' },
                        {
                          validator(rule, value) {

                            if (!value || stateabb === value || getFieldValue('statE_CODEr') === stateabb) {
                              return Promise.resolve();
                            }
                            return Promise.reject(getstatename(stateabb) + ' : Residence or business address must be in the state');
                          }
                        }],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={this.onChange}
                        placeholder="Please Select State ">
                        {States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset>
                      <legend className="legend-font">ZIP Code *</legend>
                      {getFieldDecorator('ziP_CODEb', {
                        rules: [{ required: true, message: 'Please enter a valid zip code' },
                        { pattern: /^(?:\d{5}|\d{9})$/, message: "ZIP is  must be at most 5/9 characters" }],
                      })(<Input autoComplete={"nope"} maxLength={9} className="ant-input mi_input" type="number" placeholder="Enter ZIP Code" />)}
                    </fieldset>

                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Country *</legend>
                      {getFieldDecorator('countrY_CODEb', {

                        rules: [{ required: true, message: 'Please select Country' },],
                      })(<Select disabled suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }

                        placeholder="Please Select Country ">
                        <Option value="1" key={0} >United States of America</Option>

                      </Select>)} </fieldset>
                  </Form.Item></Col>

              </Row></> : ""}
          </Col>
        </Row>
        <Row>

          <Col sm={24}>
            <div style={{ marginLeft: "15px", marginTop: "16px", marginBottom: "-16px" }}>
              <p>Mailing Address</p><Divider style={{ marginTop: "6px" }}></Divider></div>

            {getFieldDecorator('adtm', {
            })(
              <Radio.Group className="mi_input_pop" onChange={(e) => {
                this.setState({
                  disableb: this.state.disableb,
                  disabler: this.state.disabler,
                  disablem: this.state.disablem,
                  rtype: this.state.rtype,
                  btype: this.state.btype,
                  mtype: this.state.mtype,
                })
                if (e.target.value === "r" || e.target.value === "b") {
                  this.setState({
                    disablem: true,
                    mtype: e.target.value
                  })
                }
                if (e.target.value === "d") {
                  this.setState({
                    disablem: false,
                    mtype: e.target.value
                  })
                }

              }}>

                <Radio disabled={this.state.disabler} value="r">Same as resident address</Radio>
                <Radio disabled={this.state.disableb} value="b">Same as business address</Radio>
                <Radio value="d" disabled={this.state.disabler&&this.state.disableb}>Use a diffrent address</Radio>
              </Radio.Group>)}
            {!this.state.disablem ? <>
              <Row>

                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 1 *</legend>
                      {getFieldDecorator('addR_LINE_1m', {
                        rules: [{ required: true, message: 'Address Line 1 is a required' }
                          , {
                          max: 50,
                          message: "Address Line 1 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 1" />)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 2</legend>
                      {getFieldDecorator('addR_LINE_2m', {
                        rules: [{
                          max: 50,
                          message: "Address Line 2 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 2" />)}
                    </fieldset>
                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Address Line 3</legend>
                      {getFieldDecorator('addR_LINE_3m', {
                        rules: [{
                          max: 50,
                          message: "Address Line 3 is  must be at most 50 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="Address Line 3" />)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">City *</legend>
                      {getFieldDecorator('citym', {
                        rules: [{ required: true, message: 'City is a required field' }, {
                          pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                          message: "City is not valid"
                        }, {
                          max: 35,
                          message: "City is  must be at most 35 characters"
                        }],
                      })(<Input autoComplete={"nope"} maxLength={35} className="mi_input" type="text" placeholder="City" />)}
                    </fieldset>
                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">State *</legend>
                      {getFieldDecorator('statE_CODEm', {
                        rules: [{ required: true, message: 'Please select state ' },],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}

                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={this.onChange}
                        placeholder="Please Select State ">
                        {States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item></Col>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset>
                      <legend className="legend-font">ZIP Code *</legend>
                      {getFieldDecorator('ziP_CODEm', {
                        rules: [{ required: true, message: 'Please enter a valid zip code' },
                        { pattern: /^(?:\d{5}|\d{9})$/, message: "ZIP is  must be at most 5/9 characters" }
                        ],
                      })(<Input autoComplete={"nope"} maxLength={9} className="ant-input mi_input" type="number" placeholder="Enter ZIP Code" />)}
                    </fieldset>

                  </Form.Item></Col>
              </Row>
              <Row>
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Country *</legend>
                      {getFieldDecorator('countrY_CODEm', {
                        rules: [{ required: true, message: 'Please select Country' },],
                      })(<Select disabled suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />}
                        className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select Country ">
                        <Option value="1" key={0} >United States of America</Option>

                      </Select>)} </fieldset>
                  </Form.Item></Col>

              </Row></> : ""}
          </Col>
        </Row>



        <div className="collapsepanel-footer ">
          <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("exp")}> Back</Button>
          <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}> Next</Button>
        </div>

      </Form>
      </div>


    )
  }
}

const NiprAddress = Form.create()(EAD);

export default NiprAddress;